import { BusinessRoleClasses } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { routes } from "@libs/routing/routes.ts";
import { NavLink } from "@ui-components/navigation/Nav.tsx";

export const useToDoLinks = (): NavLink[] => [
  {
    name: "Inbox",
    path: routes.userInbox.basePath,
    businessRoleClasses: BusinessRoleClasses.Provider,
    showBorder: true
  },
  {
    name: "Clinical tasks",
    path: routes.tasks.clinical
  },
  {
    name: "Follow-up tasks",
    path: routes.tasks.inbox
  },
  {
    name: "Clinical reminders",
    path: routes.tasks.reminders
  },
  {
    name: "Follow-up reminders",
    path: routes.tasks.followUpReminders
  }
];
